import React from "react";
import {AlertTooltip} from "./AlertTooltip";
import {ALLOCATED_AMOUNT_GOAL, PERCENTAGE_GOAL} from "../../../../elements/BudgetPartialGoalsConfiguration";
import {DatetimeHelper} from "../../../../../utils/DatetimeHelper";
import {BU_PERIOD_TEMPORARY} from "../../../../../periods";

export class BudgetCellTooltip extends AlertTooltip {
    render() {
        let partialGoalsContent = this.partialGoalsContent();
        return (
            <div className="alert-tooltip">
                <div className="alert-tooltip-body">
                    <div className="alert-tooltip-header">
                        <div className="col-12 m-0 p-0"><p
                            className="alert-tooltip-title">PRESUPUESTOS POR TRAMOS<span></span>
                        </p></div>
                    </div>
                    {partialGoalsContent}
                </div>
            </div>

        )
    }

    partialGoalsContent() {
        return (
            <div className="alert-tooltip-content">
                <p className="alert-tooltip-description">
                    <ul>
                        {this.renderPartialGoalsItem()}
                    </ul>

                </p>
            </div>
        );
    }

    renderPartialGoalsItem() {
        const items = [];
        this.props.partialGoals.sort((a, b) => {
            return parseInt(a.date) - parseInt(b.date);
        }).forEach(partialGoal => {
            const date = this.props.periodType === BU_PERIOD_TEMPORARY ? DatetimeHelper.YYYYMMDDToFriendlyStr(partialGoal["date"]) : DatetimeHelper.YYYYMMDDToDay(partialGoal["date"]);
            if(partialGoal["type"] === ALLOCATED_AMOUNT_GOAL) {
                const percentage = partialGoal["value"] / this.props.totalBudget*100;
                const percentageAsString = `${percentage.toFixed(0)}%`;
                const valueAsString = this.formatCurrency(partialGoal["value"]);
                items.push(this.renderPartialGoalSubItem(date, valueAsString, percentageAsString));
            }

            if(partialGoal["type"] === PERCENTAGE_GOAL) {
                const percentageAsString = `${partialGoal["value"]}%`;
                const valueAsString = this.formatCurrency(partialGoal["value"]*this.props.totalBudget/100, percentageAsString);
                items.push(this.renderPartialGoalSubItem(date, valueAsString, percentageAsString));
            }
        });

        return items;
    }



    formatCurrency(amount) {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(amount);
    }

    renderPartialGoalSubItem(date, money, percentage) {
        return <li>{money} ({percentage}) al día {date}</li>;
    }
}
